import { useState } from 'react'

import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
} from '@mui/material'

import { PatternFormat } from 'react-number-format'
import FormField from 'components/FormField'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined'

import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import giftcard from '../assets/images/illustrations/giftcard.svg'
import { Image } from '@mui/icons-material'
import { selectData } from 'layouts/onboarding'
import SoftTypography from './SoftTypography'

export const ReferralModal = ({ handleClose, open }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      sx={{
        '.MuiPaper-root': {
          padding: '24px',
          borderRadius: '4px',
        },
      }}
    >
      <DialogTitle
        sx={{ fontSize: '24px', paddingBottom: '8px' }}
        textAlign="center"
      >
        Refer A Friend!
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" textAlign="center">
          When they sign up with PARCO and meet with a team member, you will
          both receive a <strong>$25 gift card</strong> to your favorite place
        </Typography>

        <Box mt={4} sx={{ display: 'flex', justifyContent: 'center' }}>
          <img src={giftcard} />
        </Box>
        <Grid container mt={4}>
          <Grid
            item
            xs={12}
            pl={0.5}
            mb={4}
            sx={{ justifyContent: 'center', alignSelf: 'center' }}
          >
            <SoftTypography
              component="label"
              variant="h4"
              fontWeight="regular"
              textTransform="capitalize"
            >
              Referral Link
            </SoftTypography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                textDecoration: 'underline',
              }}
            >
              <a>app.gopaco.com/r/fox-mulder</a>
              <a style={{ textAlign: 'right' }}>Copy Link</a>
            </Box>
          </Grid>
          <Grid item xs={12} mb={2}>
            {renderMuiFormField({
              autoFocus: false,
              id: '',
              label: 'Email Address Of Your Referral',
              placeholder: 'johnsmith@gmail.com',
              inputType: 'email',
              value: '',
            })}
          </Grid>
          <Grid item xs={12}>
            {renderMuiFormField({
              autoFocus: false,
              id: '',
              label: 'Gift Card Preference',
              placeholder: 'Select a store',
              inputType: 'select',
              options: selectData.giftCards,
              value: '',
            })}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          sx={[
            {
              fontSize: '15px',
              padding: '10px 24px 9px',
              backgroundColor: '#fff',
              color: '#344767',
              fontWeight: '500',
              boxShadow: 'none',
              textTransform: 'none',
            },
            {
              '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                transform: 'none',
                backgroundColor: '#f9f9f9',
                boxShadow: 'none',
              },
            },
          ]}
          onClick={handleClose}
          autoFocus
        >
          PREVIEW EMAIL
        </Button>
        <Button
          variant="contained"
          sx={{
            borderRadius: 1,
            fontSize: '15px',
            padding: '10px 24px 9px',
            backgroundColor: '#344767',
            color: '#fff',
            fontWeight: 'normal',
            boxShadow: 'none',
            textTransform: 'none',
            '&:hover, &:focus, &:active, &:focus:not(:hover)': {
              transform: 'none',
              backgroundColor: '#293852',
              boxShadow: 'none',
            },
          }}
          onClick={handleClose}
          autoFocus
        >
          SEND EMAIL
        </Button>
      </DialogActions>
    </Dialog>
  )
}
